"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var React = _interopRequireWildcard(require("react"));
var _styles = require("@material-ui/styles");
var _classnames = _interopRequireDefault(require("classnames"));
var _AvatarV = _interopRequireDefault(require("../AvatarV2/AvatarV2"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: _objectSpread(_objectSpread({}, theme.typography.header5), {}, (0, _defineProperty2.default)({
      fontWeight: 600,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '2rem',
      height: '2rem',
      backgroundColor: 'transparent',
      color: theme.colors.black,
      '&:hover, &:focus, &:active': {
        color: theme.colors.battleshipGrey
      }
    }, theme.breakpoints.gte.mobile.portrait, {
      width: '2.75rem',
      height: '2.75rem'
    }))
  };
});
/*:: type Props = {
  children:
    | React.Element<typeof AvatarV2>
    | React.Element<'img'>
    | React.Element<'svg'>
    | null,
  className?: string,
  onClick?: (event: SyntheticInputEvent<HTMLButtonElement>) => mixed,
  tabIndex?: number
};*/
var NavButton = function NavButton(_ref /*:: */) {
  var children = _ref /*:: */.children,
    className = _ref /*:: */.className,
    onClick = _ref /*:: */.onClick,
    tabIndex = _ref /*:: */.tabIndex;
  var classes = useStyles();
  return /*#__PURE__*/React.createElement("button", {
    className: (0, _classnames.default)(classes.root, className),
    onClick: onClick,
    tabIndex: tabIndex
  }, children);
};
NavButton.displayName = 'NavButton';
var _default = exports.default = NavButton;
//# sourceMappingURL=NavButton.js.map